import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "count"]

  connect() {
    this.updateAnswerFields()
  }

  updateAnswerFields() {
    const desiredCount = parseInt(this.countTarget.value, 10)
    const currentFields = this.containerTarget.querySelectorAll("[data-answer-field]")
    const currentCount = currentFields.length

    if (desiredCount > currentCount) {
      // Add more fields
      for (let i = currentCount; i < desiredCount; i++) {
        this.addAnswerField(i)
      }
    } else if (desiredCount < currentCount) {
      // Remove extra fields (mark for destruction or remove if new)
      for (let i = currentCount - 1; i >= desiredCount; i--) {
        const field = currentFields[i]
        const destroyInput = field.querySelector("input[name*='_destroy']")
        const idInput = field.querySelector("input[name*='[id]']")

        if (idInput && idInput.value) {
          // Existing record: mark for destruction and hide
          destroyInput.value = "1"
          field.style.display = "none"
          field.removeAttribute("data-answer-field")
        } else {
          // New record: just remove from DOM
          field.remove()
        }
      }
    }
  }

  addAnswerField(index) {
    const timestamp = new Date().getTime() + index
    const template = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, timestamp)
    this.containerTarget.insertAdjacentHTML("beforeend", template)
  }
}
